import settings from "../default-icons/settings";
import copy from "../default-icons/copy";
import check from "../default-icons/check";
import user from "../default-icons/user";
import loading from "../default-icons/loading";
export default { settings, copy, check, user, loading };
